// src/utils/formatDate.js — shared relative and absolute date formatting
// Used app-wide. No abbreviated suffixes (Xd, Xw, Xh, Xm) anywhere.

const TODAY = new Date().toISOString().slice(0, 10);

export function formatRelativeDate(dateStr, today = TODAY) {
  if (!dateStr) return '';
  const date = new Date(dateStr + 'T12:00:00');
  const now  = new Date(today + 'T12:00:00');
  const diffDays = Math.round((now - date) / 86400000);
  if (diffDays === 0)  return 'today';
  if (diffDays === 1)  return 'yesterday';
  if (diffDays <= 6)   return `${diffDays} days ago`;
  // Beyond 6 days: short date, include year if different
  return date.toLocaleDateString('en-US', {
    month: 'short', day: 'numeric',
    ...(date.getFullYear() !== now.getFullYear() ? { year: 'numeric' } : {}),
  });
}

export function formatShortDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr + 'T12:00:00').toLocaleDateString('en-US', {
    month: 'short', day: 'numeric',
  }).toLowerCase();
}

export function formatFullDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr + 'T12:00:00').toLocaleDateString('en-US', {
    weekday: 'short', month: 'short', day: 'numeric',
  });
}

// Compute "Xd" payday style → "in N days" or "today" or "tomorrow"
export function formatDaysUntil(days) {
  if (days === null || days === undefined) return '—';
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days < 0)  return `${Math.abs(days)} days ago`;
  return `in ${days} days`;
}

// Time-aware relative formatting — for sync timestamps etc.
// Pass a full Date object or ISO string with time component
export function formatRelativeTime(dateOrStr) {
  if (!dateOrStr) return '';
  const date = dateOrStr instanceof Date ? dateOrStr : new Date(dateOrStr);
  const diffMs = Date.now() - date.getTime();
  const diffMin = Math.round(diffMs / 60000);
  const diffHr  = Math.round(diffMs / 3600000);
  if (diffMin < 1)  return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHr < 24)  return `${diffHr}h ago`;
  const diffDays = Math.round(diffMs / 86400000);
  if (diffDays === 1) return 'yesterday';
  if (diffDays < 7)  return `${diffDays} days ago`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
